import React, { useState } from 'react';
import VerifyForm from './VerifyForm';
import RegisterForm from './RegisterForm';
import { ConfirmationResult } from 'firebase/auth';
import './AuthPage.css'; // Import the CSS file
const AuthPage = () => {
    const [confirmationResult, setConfirmationResult] = useState<ConfirmationResult | null>(null);

    const handleRegister = (confirmationResult: ConfirmationResult) => {
        setConfirmationResult(confirmationResult);
    }

    return (
        <div className="authPage">
            <p> To Sign In or Sign Up, please type in your phone number below </p>
            {!confirmationResult ? (
                <RegisterForm onRegister={handleRegister} />
            ) : (
                <VerifyForm confirmationResult={confirmationResult} />
            )}
        </div>
    );
}

export default AuthPage;